module.exports = __webpack_public_path__ + "static/img/weibocode.f390e78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weibocode.jpg
// module id = 23
// module chunks = 1 2 3 5 6 7 8 9